import*as e from"react";import r from"@mui/material/GlobalStyles";import{global as l}from"../internals/FlowChartStyles.js";const m=({children:t})=>e.createElement(e.Fragment,null,e.createElement(r,{styles:l}),t);export{m as default};
